/**
 * @generated SignedSource<<df41c7688809cc4431206b294df7a9b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UploadAttachmentInput = {
  ticketId: string;
  filename?: string | null;
  contentType?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type uploadAttachmentMutation$variables = {
  input: UploadAttachmentInput;
};
export type uploadAttachmentMutation$data = {
  readonly uploadAttachment: {
    readonly clientMutationId: string | null;
    readonly attachment: {
      readonly id: string;
      readonly filename: string;
      readonly contentType: string;
      readonly sizeBytes: number;
      readonly storageKey: string | null;
      readonly downloadUrl: string;
      readonly createdAt: string;
    } | null;
  } | null;
};
export type uploadAttachmentMutation = {
  variables: uploadAttachmentMutation$variables;
  response: uploadAttachmentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UploadAttachmentPayload",
    "kind": "LinkedField",
    "name": "uploadAttachment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TicketAttachment",
        "kind": "LinkedField",
        "name": "attachment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "filename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contentType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sizeBytes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "storageKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "downloadUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "uploadAttachmentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uploadAttachmentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f4c19ed2040663f75ddea403c6e7c02a",
    "id": null,
    "metadata": {},
    "name": "uploadAttachmentMutation",
    "operationKind": "mutation",
    "text": "mutation uploadAttachmentMutation(\n  $input: UploadAttachmentInput!\n) {\n  uploadAttachment(input: $input) {\n    clientMutationId\n    attachment {\n      id\n      filename\n      contentType\n      sizeBytes\n      storageKey\n      downloadUrl\n      createdAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5f2a1df29ee1049019b1c498150f246f";

export default node;
